import basicRest from '../common/CommonRestFunctions'

const basePackagingTypeUrl = '/packaging-type'
const baseGrainTypeUrl = '/grain-type'
const baseQualityTypeUrl = '/quality-type'
const baseAgrochemicalTypeUrl = '/agrochemical-type'
const baseAgrochemicalAppTypeUrl = '/agrochemical-application-type'

export default {
  getPackagingTypes () {
    return basicRest.executeBasicAxiosGet(basePackagingTypeUrl + '/list')
  },
  getGrainTypes () {
    return basicRest.executeBasicAxiosGet(baseGrainTypeUrl + '/list')
  },
  getAgrochemicalTypes () {
    return basicRest.executeBasicAxiosGet(baseAgrochemicalTypeUrl + '/list')
  },
  getAgrochemicalApplicationTypes () {
    return basicRest.executeBasicAxiosGet(baseAgrochemicalAppTypeUrl + '/list')
  },
  getQualityTypes () {
    return basicRest.executeBasicAxiosGet(baseQualityTypeUrl + '/list')
  }
}
